/*
 * @Author: 317473294@qq.com
 * @Date: 2023-10-26 20:03:10
 * @LastEditTime: 2024-10-10 22:52:01
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/router/dtRouter.js
 */
import layout from '@/layout/layout'
import {getRoleMenu} from "@/api/menu.js"
import {roleMenu} from "@/utils/rolemenu.js"

import router,{ resetRouter } from "@/router";
var lsroles=[]
export const asyRouterList=[
  {
    path: '/home',
    name: '数据展示',
    icon:"el-icon-s-data",
    component: layout,
   redirect: '/bigScreen',//子页定向到word页面，输入home,子页面显示word
    // hidden: true,
    children: [
      {
        path: "/bigScreen",//主页默认显示单词页面
        name: "数据详情",
        component: resolve => require(['@/views/bigScreen/bigScreen.vue'], resolve),
        meta: { title: '数据详情', icon: 'el-icon-s-data',requiresAuth:true },
      },
    ]
  },
]
//2获取权限菜单id数组,参数为登陆以后拿到用户角色ID，通过角色ID,拿到对应的权限菜单id
export  function getRoleMenuIds(roleid){
  return new Promise(async(resolve,rejcect)=>{
    let data=await roleMenu({id:roleid})
    let meunsids=data[0].limtauthority//拿到权限菜单id字符串
    let menusArray = meunsids.split(",");//把字符串转成数组,这逗号是中文
    // console.log("====",menusArray)
    let treeData=await initMenuData({ids:menusArray})//获取树形结构菜单
    // resetRouter()
    router.addRoutes(treeData)
    resolve(treeData)
  })
}
  //3获取菜单，参数为权限菜单对象ids数组{ids:menusArray}
const initMenuData=(ids)=>{
    return new Promise((resolve,rejcect)=>{
      getRoleMenu(ids).then((res) => {
        const data = res.data.data
        // console.log("拿到的菜单数据",data)
        localStorage.setItem("menus",JSON.stringify(data))
        const treedata=tranArrToTreeData(data)
        resolve(treedata)  
    })
    })  
  }
//把后台获取到的路由封装成树形结构，同时添加相关按钮权限
export function  tranArrToTreeData(list){
  // console.log("执行了",list)
  const treeList = [],  // 最终要产出的树状数据的数组
          map = {}     // 存储映射关系
  list.forEach(item => {
          if (!item.children) {  // 如果list遍历出来的数据没有children，就给他的数据里增加一个children，并赋值一个空数组
                  item.children = []
                  item.meta={requiresAuth:true,roles:[]}
          }
          map[item.keyid] = item  //这里的map是一个空对象
          
  })
  list.forEach(item => {
          // 对于每一个元素来说，先找它的上级
          //    如果能找到，说明它有上级，则要把它添加到上级的children中去
          //    如果找不到，说明它没有上级，直接添加到 treeList
          const parent = map[item.parentid]
          // parent.meta={roles:[]}
         // item.meta={requiresAuth:true,roles:[]}//requiresAuth=true,用户必须登陆才能访问
          //item.component过滤掉按钮；因为按钮类型component为空
          if (parent) {
            //添加按钮权限，如果类型为3则为按钮，同时parent的keyid与按钮的parentid相同，说明按钮在parent节点下，把按钮权限添加到parent
              if(item.type==3&&parent.keyid==item.parentid){
                // console.log(item)
                // console.log(parent)
               // parent.meta={roles:[]}//动态定义meata属性，属性里面添加按钮权限控制
                // lsroles.push(item.permissionident)
                parent.meta.roles.push(item.permissionident)
              
              }else{
                const component=item.component+".vue"//这里.vue可写可不写
                item.component=()=> import(`@/views${component}`)//打开正确方式
                parent.children.push(item)
              }
        
          } else if(item.component!=""){//按钮类型组件就是空字符
                  // 如果不存在 则是顶层数据
                  item.component=layout,
                  treeList.push(item)
                  
          }
  })
  return treeList
}



  
   


// WEBPACK FOOTER //
// ./src/router/dtRouter.js